import * as constants from "./constants";

export default function(state, action){
    if (!state || action.type == constants.OPERATOR_PHONE_LIST_CLEAR_STORE){

        let oldPhoneList = undefined;
        if(!!state){
            oldPhoneList = state.phoneList;
        }

        state = {
            name: "Тест",

            phoneListSummury: [],
            phoneList: oldPhoneList || [],
            userList: [],
            isLoading: false,
            isSave: false,
            isLoaded: false
        };

    }

    switch(action.type){
        case constants.OPERATOR_PHONE_LIST_SUMMURY_LOAD_START:
            return {...state, ...{phoneListSummury: [], isLoading: true, error: undefined}};
        case constants.OPERATOR_PHONE_LIST_SUMMURY_LOAD_SUCCESS:
            return { ...state, ...{phoneListSummury: action.data, isLoading: false}};
        case constants.OPERATOR_PHONE_LIST_SUMMURY_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.OPERATOR_PHONE_LIST_LOAD_START:
            return {...state, ...{phoneList: [], isLoading: true, error: undefined}};
        case constants.OPERATOR_PHONE_LIST_LOAD_SUCCESS:
            return { ...state, ...{phoneList: action.data, isLoading: false}};
        case constants.OPERATOR_PHONE_LIST_LOAD_FAIL:
            return {...state, ...{isLoading: false, error: action.error}};

        case constants.OPERATOR_PHONE_LIST_RESET_TOKEN_START:
            return {...state, ...{isLoading: true}};
        case constants.OPERATOR_PHONE_LIST_RESET_TOKEN_SUCCESS:
            return { ...state, ...{isLoading: false, isShouldReload: true}};
        case constants.OPERATOR_PHONE_LIST_RESET_TOKEN_FAIL:
            return {...state, ...{isLoading: true, error: action.error}};

        default:
            return state;
    }
}
